// extracted by mini-css-extract-plugin
export default {"pageContainer":"Projects_pageContainer__-z7d-","wrapper":"Projects_wrapper__Dc4Zt"};